module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-temptation.431ded6e.svg";